import { render } from "./CommonAuthor.vue?vue&type=template&id=10a479d6"
import script from "./CommonAuthor.vue?vue&type=script&lang=js"
export * from "./CommonAuthor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__